// Flujos para rutas que NO exigen idCertificado.
const decideAuthFlowSinCertificado = ({ urlUuid, hasStoreToken, hasCookie }) => {
  if (!urlUuid && hasStoreToken) {
    return { action: 'authenticated' }
  }
  if (!urlUuid && hasCookie) {
    return { action: 'call-api', params: { skipCertValidation: true }, hasUuid: false }
  }
  if (urlUuid) {
    return { action: 'call-api', params: { uuid: urlUuid, skipCertValidation: true }, hasUuid: true }
  }
  return { action: 'no-session' }
}

// Flujos para rutas que SÍ exigen idCertificado.
// Preserva el comportamiento original: urlUuid + !idcertificadoUrl → no-session.
const decideAuthFlowConCertificado = ({ urlUuid, hasStoreToken, hasCookie, idcertificadoUrl, storeIdCertificado }) => {
  if (urlUuid) {
    if (!idcertificadoUrl) {
      return { action: 'no-session' }
    }
    return { action: 'call-api', params: { uuid: urlUuid, idCertificado: idcertificadoUrl }, hasUuid: true }
  }

  if (hasStoreToken) {
    if (idcertificadoUrl && idcertificadoUrl !== storeIdCertificado) {
      return { action: 'call-api', params: { idCertificado: idcertificadoUrl }, hasUuid: false }
    }
    return { action: 'authenticated' }
  }

  if (hasCookie) {
    const params = idcertificadoUrl ? { idCertificado: idcertificadoUrl } : undefined
    return { action: 'call-api', params, hasUuid: false }
  }

  return { action: 'no-session' }
}

/**
 * Decide qué flujo de autenticación ejecutar según el estado de la URL y la sesión.
 *
 * Devuelve { action, params?, hasUuid? } donde:
 *   action: 'authenticated' | 'no-session' | 'call-api'
 *   params: args para checkAuth (solo si action='call-api')
 *   hasUuid: true cuando se detectó uuid en URL que requiere limpiar query params
 */
export const decideAuthFlow = ({
  requiereIdCertificado,
  urlUuid,
  hasStoreToken,
  hasCookie,
  idcertificadoUrl,
  storeIdCertificado,
}) => {
  if (requiereIdCertificado) {
    return decideAuthFlowConCertificado({
      urlUuid,
      hasStoreToken,
      hasCookie,
      idcertificadoUrl,
      storeIdCertificado,
    })
  }

  return decideAuthFlowSinCertificado({
    urlUuid,
    hasStoreToken,
    hasCookie,
  })
}
